module.exports = __webpack_public_path__ + "img/home-volunteer.d1a5d945.jpg";